module.exports = __webpack_public_path__ + "static/media/2_IPP Simone Kong (President)-min.84b105e0.jpg";